<template>
  <div class="trialoperation">
    <div class="container">
      <!-- Content here -->
      <br />

      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <b-navbar-brand href="#">
          <img
            src="./../assets/logo.png"
            class="d-inline-block align-top"
            width="30"
            height="30"
            alt="logo"
          />
          代買幫 - 代買費用試算
        </b-navbar-brand>
      </nav>
      <br />
      <b-button block variant="info" @click="gotoMessage()"
        >直接開始使用</b-button
      >
      <br />
      <div class="card">
        <div class="card-body">
          <div>
            <p>請輸入商品價格(人民幣) :</p>
            <b-form-input
              v-model="price"
              v-bind:placeholder="price"
            ></b-form-input>
          </div>
          <br />
          <div>
            <p>請輸入預估重量(KG) :</p>
            <b-form-input
              v-model="prodWeight"
              v-bind:placeholder="prodWeight"
            ></b-form-input>
          </div>
          <br />
          <div>
            請輸入預估商品長(CM) :
            <b-form-input
              v-model="prodLength"
              v-bind:placeholder="prodLength"
            ></b-form-input>
          </div>
          <div>
            請輸入預估商品寬(CM) :
            <b-form-input
              v-model="prodWidth"
              v-bind:placeholder="prodWidth"
            ></b-form-input>
          </div>
          <div>
            請輸入預估商品高(CM) :
            <b-form-input
              v-model="prodHeight"
              v-bind:placeholder="prodHeight"
            ></b-form-input>
          </div>
          <br />

          <b-container class="bv-example-row">
            <b-row>
              <b-col>
                <toggle-button :value="true" v-model="selectedCategory" />
                <br />選擇:
                <b v-if="selectedCategory">普貨</b>
                <b v-else>特貨</b>
              </b-col>
              <b-col>
                <toggle-button :value="true" v-model="selectedTransport" />
                <br />選擇:
                <b v-if="selectedTransport">宅配</b>
                <b v-else>超商取貨</b>
              </b-col>
              <b-col>
                <toggle-button :value="true" v-model="selectedOutside" />
                <br />選擇:
                <b v-if="selectedOutside">本島</b>
                <b v-else>外島</b>
              </b-col>
            </b-row>
          </b-container>
          <b-container class="bv-example-row">
            <b-row>
              <b-col>
                <toggle-button :value="true" v-model="selectedType" />
                <br />選擇:
                <b v-if="selectedType">空運(2~3)天</b>
                <b v-else>海快(星期一、三、五出貨)</b>
              </b-col>
            </b-row>
          </b-container>

          <div v-if="totalPrice != 0">
            <br />
            <b-card border-variant="info" header="試算結果" align="center">
              <b-card-text>商品價格:{{ prodPrice }} NTD</b-card-text>
              <b-card-text>國際運費:{{ transportPrice }} NTD</b-card-text>
              <b-card-text>金流手續費:{{ paymentRate }} NTD</b-card-text>
              <b-card-text>代買幫手續費:{{ chatxbuyRate }} NTD</b-card-text>
              <b-card-text>
                <b>總共金額:{{ totalPrice }} NTD</b>
              </b-card-text>
              <br />
              <b-button block variant="info" @click="gotoMessage()"
                >立即使用</b-button
              >
              <b-button block variant="info" @click="computedTotalPrice()"
                >重新試算</b-button
              >
            </b-card>
          </div>
          <div v-else-if="errorMessage != ''">
            <br />
            <b-alert show variant="danger">{{ errorMessage }}</b-alert>
            <br />
            <b-button block variant="info" @click="computedTotalPrice()"
              >重新試算</b-button
            >
          </div>
          <div v-else>
            <br />
            <b-button block variant="info" @click="computedTotalPrice()"
              >開始試算</b-button
            >
          </div>
        </div>
      </div>
      <br />
      <b-card
        border-variant="danger"
        header="代買幫運費規則"
        header-border-variant="danger"
        header-text-variant="danger"
        align="center"
      >
        <b-card-text>
          目前訂單匯率:
          <b>{{ exchangeRate }}</b>
        </b-card-text>
        <b-card-text>
          <b>空運普貨(10公斤以內包稅)</b>：5公斤以下按實際重量算 (商品重量 *
          訂單匯率 * 18.5人民幣 + 75台幣）（如果超商取貨另加收40台幣)
        </b-card-text>
        <b-card-text
          >6公斤～10公斤 每公斤22.5人民幣 * 訂單匯率 + 75台幣
          (公斤小數點無條件進位)</b-card-text
        >
        <b-card-text
          >(不包稅)11公斤～70公斤 每公斤20.5人民幣 * 訂單匯率 + 75台幣
          (公斤小數點無條件進位)</b-card-text
        >
        <br />
        <b-card-text>
          <b>空運特貨(10公斤以內包稅)</b>：18公斤以下按實際重量算 (商品重量 *
          訂單匯率 * 20.5人民幣 + 75台幣）（如果超商取貨另加收40台幣)
        </b-card-text>
        <b-card-text
          >19公斤～70公斤 每公斤22.5人民幣 * 訂單匯率 + 75台幣
          (公斤小數點無條件進位)</b-card-text
        >
        <br />
        <b-card-text>
          <b>海快普貨/特貨 (不包稅)</b>：每公斤11人民幣 * 訂單匯率
          (未滿10公斤以10公斤計算​，只能宅配)
        </b-card-text>
        <br />

        <b-card-text
          >*代買幫手續費 30元， 綠界金流手續費 1%/筆，最低10元</b-card-text
        >
        <b-card-text
          >*超商取貨最重 5公斤 不支援，長, 寬, 高不能超過 45cm， 30cm，
          30cm</b-card-text
        >
        <b-card-text>*宅配最重 70公斤，長， 寬， 高 不超過 150cm</b-card-text>
        <b-card-text
          >*如果材積重量大於實際重量*2，將會以 (材積重量 + 實際重量)/2
          公斤做計算</b-card-text
        >
        <b-card-text
          >*外島地區 澎湖、馬祖、綠島、小琉球、蘭嶼、金門 地區
          +300NTD</b-card-text
        >
      </b-card>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<style type="text/css"></style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
export default {
  name: 'trialoperation',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      isLoading: true,
      userId: '',
      userImage: '',
      userName: '',
      price: '',
      prodWeight: '',
      prodLength: '',
      prodWidth: '',
      prodHeight: '',
      prodPrice: '',
      transportPrice: 0,
      chatxbuyRate: 30,
      paymentRate: 0,
      totalPrice: 0,
      exchangeRate: 4.7,
      selectedCategory: true,
      selectedTransport: true,
      selectedOutside: true,
      selectedType: true,
      errorMessage: '',
    }
  },
  watch: {
    selectedType: function (type) {
      const vm = this
      if (type == false) {
        vm.selectedTransport = true
        vm.$forceUpdate()
      }
      if (vm.prodWeight < 10) {
        alert('海快要10公斤以上喔，不支援超商取貨')
      }
    },
  },
  methods: {
    computedTotalPrice: function () {
      const vm = this
      vm.prodPrice = Math.ceil(vm.price * vm.exchangeRate)

      let tmpPrice = 0

      // 長度 x 寬度 x 高度／5000
      let tmpW = (vm.prodLength * vm.prodWidth * vm.prodHeight) / 5000

      if (tmpW > vm.prodWeight * 2) {
        vm.prodWeight = Math.ceil((tmpW + vm.prodWeight) / 2)
      }
      // 空運
      if (vm.selectedType) {
        if (vm.selectedCategory) {
          if (vm.prodWeight <= 5) {
            tmpPrice = Math.ceil(vm.prodWeight * 18.5 * vm.exchangeRate)
          } else if (vm.prodWeight >= 6 && vm.prodWeight >= 10) {
            tmpPrice = Math.ceil(vm.prodWeight * 22.5 * vm.exchangeRate)
          } else if (vm.prodWeight >= 11 && vm.prodWeight >= 70) {
            tmpPrice = Math.ceil(vm.prodWeight * 20.5 * vm.exchangeRate)
          } else {
            vm.errorMessage = '不支援70公斤以上的商品'
            return
          }
        } else {
          if (vm.prodWeight <= 18) {
            tmpPrice = Math.ceil(vm.prodWeight * 20.5 * vm.exchangeRate)
          } else if (vm.prodWeight >= 19 && vm.prodWeight >= 70) {
            tmpPrice = Math.ceil(vm.prodWeight * 22.5 * vm.exchangeRate)
          } else {
            vm.errorMessage = '不支援70公斤以上的商品'
            return
          }
        }

        if (vm.selectedTransport) {
          tmpPrice = tmpPrice + 75
          if (
            vm.prodWeight > 70 ||
            vm.prodLength > 150 ||
            vm.prodWidth > 150 ||
            vm.prodHeight > 150
          ) {
            vm.errorMessage =
              '宅配不支援70公斤以上的商品，長, 寬, 高 不超過 150cm'
            return
          }
        } else {
          tmpPrice = tmpPrice + 75 + 40
          if (
            vm.prodWeight > 5 ||
            vm.prodLength > 45 ||
            vm.prodWidth > 30 ||
            vm.prodHeight > 30
          ) {
            vm.errorMessage =
              '超商取貨不支援5公斤以上的商品，長, 寬, 高不能超過 45, 30, 30cm'
            return
          }
        }
      } else if (vm.selectedType == false) {
        // 海快
        tmpPrice = Math.ceil(vm.prodWeight * 11 * vm.exchangeRate)
      }

      if (vm.selectedOutside) {
        tmpPrice = tmpPrice + 0
      } else {
        tmpPrice = tmpPrice + 300
      }

      // 運費
      vm.transportPrice = tmpPrice

      // 金流費
      let tmpPaymentRate = 0
      if (vm.selectedType) {
        tmpPaymentRate = Math.ceil(
          Math.ceil(vm.transportPrice + vm.prodPrice + vm.chatxbuyRate) * 0.01
        )
      } else if (vm.selectedType == false) {
        tmpPaymentRate = Math.ceil(
          Math.ceil(vm.transportPrice + vm.prodPrice + vm.chatxbuyRate) * 0.015
        )
      }

      if (tmpPaymentRate <= 10) {
        tmpPaymentRate = 10
      }

      vm.paymentRate = tmpPaymentRate

      // 總金額
      vm.totalPrice =
        vm.transportPrice + vm.prodPrice + vm.paymentRate + vm.chatxbuyRate

      vm.$forceUpdate()
    },
    gotoMessage: function () {
      window.location = 'https://m.me/2266831083395361'
    },
    getExchangeRate: function () {
      const vm = this
      ;(async function post() {
        let formData = {}

        await axios
          .post(vm.apiUrl + 'GetExchangeRate', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            vm.exchangeRate = data.exchange_rate
            vm.isLoading = false
            vm.$forceUpdate()
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '抓取匯率失敗請通知客服!' + error,
              type: 'error',
            })
          })
      })()
    },
  },
  computed: {},
  mounted() {
    const vm = this
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    // Event snippet for 進入機器人試算頁面 conversion page
    vm.$ga.event('event', 'conversion', {
      send_to: 'AW-700538278/LFgLCKW44rIBEKa7hc4C',
      value: 1.0,
      currency: 'TWD',
    })

    vm.getExchangeRate()
  },
}
</script>
